import React, { useEffect, useRef } from "react";
import { useQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import { GET_PROJECTS } from "../graphql/queries";
import { ROUTES } from "../routes/routes";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function ProjectList({ input }) {
    const { loading, error, data } = useQuery(GET_PROJECTS);
    const containerRef = useRef(null);

    useEffect(() => {
        if (data) {
            gsap.fromTo(
                containerRef.current,
                { opacity: 0, y: 20 },
                {
                    opacity: 1,
                    y: 0,
                    scrollTrigger: {
                        trigger: containerRef.current,
                        start: "top 80%",
                        end: "bottom 60%",
                        toggleActions: "play none none none",
                    },
                    duration: 1,
                }
            );
        }
    }, [data]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const filteredData = data.portfolios.filter((el) => {
        if (!input) {
            return el;
        } else {
            return el.title.toLowerCase().includes(input.toLowerCase());
        }
    });

    const getRandomColor = () => {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    return (
        <div className="post-container" ref={containerRef}>
            {filteredData.map((post) => (
                <Link
                    to={`${ROUTES.project.path}/${post.slug}`}
                    key={`project-${post.slug}`}
                >
                    <div key={post.id} className="card">
                        <div
                            className="card-image"
                            style={{ backgroundColor: getRandomColor() }}
                        >
                            <img src={post.image.url} alt={post.title} />
                        </div>
                        <div className="card-content">
                            <h2>{post.title}</h2>
                            <p className="card-description">
                                {post.description}
                            </p>
                            <p className="card-date">{post.author}</p>
                        </div>
                    </div>
                </Link>
            ))}
        </div>
    );
}
